import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'style.css';

interface PostMeta {
    slug: string;
    title: string;
    date: string;
    excerpt: string;
    coverImage: string;
}

const formatDate = (iso: string) =>
    new Date(iso + 'T12:00:00').toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric',
    });

const Blog = () => {
    const [posts, setPosts] = useState<PostMeta[]>([]);

    useEffect(() => {
        fetch('/blog/posts.json')
            .then(r => r.text())
            .then(text => JSON.parse(text.replace(/,\s*([}\]])/g, '$1')))
            .then((data: PostMeta[]) => setPosts([...data].reverse()));
    }, []);

    return (
        <div className="blog-page">
            <h1 className="blog-heading">Progress Updates</h1>
            <div className="blog-grid">
                {posts.map(post => (
                    <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
                        <div className="blog-card-img-wrap">
                            <img src={post.coverImage} alt={post.title} className="blog-card-img" loading="lazy" />
                        </div>
                        <div className="blog-card-body">
                            <span className="blog-card-date">{formatDate(post.date)}</span>
                            <h2 className="blog-card-title">{post.title}</h2>
                            <p className="blog-card-excerpt">{post.excerpt}</p>
                            <span className="blog-card-cta">Read more →</span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Blog;
